import { Col, Form, message, Modal, Row } from "antd";
import React, { useState } from "react";
import {
	DatePickerWithMask,
} from "../../../components";
import moment from "moment";
import { timeCardService } from "../../../redux/services";

const ModalSendToSign = ({
    visible,
    onClose,
    empresa_id,
    funcionario_id,
    data_inicial,
    data_final
}) => {
    const [isSending, setIsSending] = useState(false);
    const [dataInicial, setDataInicial] = useState(data_inicial);
    const [dataFinal, setDataFinal] = useState(data_final);
    const [dataFinalError, setDataFinalError] = useState(false);
    const [form, setForm] = useState();

    const onSubmit = () => {
        setIsSending(true);
        form.validateFields();

        timeCardService.enviarParaAssinatura({
            empresa_id,
            funcionario_id,
            data_inicio: dataInicial,
            data_fim: dataFinal
        }).then((response) => {
            message.success('Enviado com sucesso!');
            setIsSending(false);
            onClose();
        }).catch((data) => {
            Modal.error({
                title  : 'Ocorreu um erro!',
                content: String(data),
            })
            setIsSending(false);
        });
    }

    const onCloseModal = () => {
        if (onClose) onClose();
    }

    return (
        <Modal
            visible={visible}
            title="Enviar Cartão Ponto para assinatura"
            wrapClassName="modal-scroll"
            destroyOnClose={true}
            maskClosable={false}
            width={580}
            okText={isSending ? "Enviando" : "Enviar"}
            cancelButtonProps={{disabled: isSending}}
            onCancel={onCloseModal}
            onOk={onSubmit}
            confirmLoading={isSending}
            keyboard={!isSending}
            closable={!isSending}
            centered
        >
            <Form
                ref={el => setForm(el)}
                layout="vertical"
                scrollToFirstError
                initialValues={{
                    datainicial: moment(data_inicial),
                    datafinal: moment(data_final),
                }}
            >
                <Row><Form.Item>Confirme o período de cartão ponto a ser enviado</Form.Item></Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <DatePickerWithMask 
                            onChange={(e) => setDataInicial(e.format("YYYY-MM-DD"))} 
                            label="Data Inicial" 
                            name="datainicial" 
                            required={true}
                        />
                    </Col>

                    <Col span={12}>
                        <DatePickerWithMask 
                            onChange={(e) => {
                                const dataFinal = e.format("YYYY-MM-DD");
                                if (dataInicial > dataFinal) {
                                    message.error("A data final não pode ser menor que a data inicial.");
                                    setDataFinal(dataFinal);
                                    setDataFinalError(true)
                                    return;
                                }
                                setDataFinal(dataFinal);
                            }}
                            label="Data Final" 
                            name="datafinal" 
                            // disabled={isDisabled}
                            required={true}
                            onKeyUp={(e) => {
                                if (e.keyCode === 9) {
                                    this.form?.datafinal.focus();
                                }
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: "Campo obrigatório.",
                                },
                                {
                                    validator(_, value) {
                                        if (!dataFinalError) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error("A data final não pode ser menor que a data inicial."));
                                    },
                                },
                            ]}
                        />
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}

export default ModalSendToSign;